import { styled } from "@mui/material/styles";
import { SpaceXs, ColorWhite, SpaceLg, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { IconButton } from "../../../Inputs/IconButton/index.js";
const CarouselNavigationButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "navigationButtonBottomOffset" && prop !== "navigationButtonTopOffset" && prop !== "isScrollbar"
})(({
  navigationButtonBottomOffset,
  navigationButtonTopOffset,
  isScrollbar
}) => {
  const positionStyles = navigationButtonBottomOffset !== "auto" && navigationButtonTopOffset !== "auto" ? { bottom: navigationButtonBottomOffset } : {
    bottom: navigationButtonBottomOffset,
    top: navigationButtonTopOffset
  };
  return {
    "&, &:hover": {
      backgroundColor: ColorWhite,
      boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.3)",
      zIndex: 1
    },
    padding: SpaceXs,
    position: isScrollbar ? "relative" : "absolute",
    ...positionStyles
  };
});
const chevronStylesSx = {
  color: ColorGray900,
  height: SpaceLg,
  width: SpaceLg
};
export {
  CarouselNavigationButton,
  chevronStylesSx
};
